export class PromotedJobsApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getJobG8ReadyJobs() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/promoted-jobs/xml',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getPromotedJob({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/promoted-jobs/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    updatePromotion({ id, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/promoted-jobs/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getPromotedJobByJobId({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/promoted-jobs/job/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns PromotedJob
     * @throws ApiError
     */
    create({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/jobs-board/promoted-jobs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    pausePromotion({ id, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/promoted-jobs/{id}/pause',
            path: {
                'id': id,
            },
        });
    }
}
